import { render, staticRenderFns } from "./TeamPage.vue?vue&type=template&id=8a9590f4&scoped=true&"
import script from "./TeamPage.vue?vue&type=script&lang=js&"
export * from "./TeamPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9590f4",
  null
  
)

export default component.exports